import { render, staticRenderFns } from "./dashboard-components-sidebar-add-widgets.vue?vue&type=template&id=1db0c419&scoped=true&"
import script from "./dashboard-components-sidebar-add-widgets.ts?vue&type=script&lang=ts&"
export * from "./dashboard-components-sidebar-add-widgets.ts?vue&type=script&lang=ts&"
import style0 from "./dashboard-components-sidebar-add-widgets.scss?vue&type=style&index=0&id=1db0c419&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db0c419",
  null
  
)

export default component.exports